import React from 'react'

const PrivateRoute = () => {
  return (
    <div>
        <p className='text-center text-blue-500 font-semibold text-2xl'>Please Login first, You are not Authorised person</p>
    </div>
  )
}

export default PrivateRoute